import React, { useRef, useEffect, useState } from "react";
import { FormItemTypeEnum, IYhForm, IYhFormRef } from "@/components/YhFormBox/Types";
import { AppDrawer } from "@/components/YhDrawer";
import { YhForm } from "@/components/YhFormBox";
import { useAccountModel } from "./accountModel";
import { message } from "antd";
import { accountService, creditFlagDs, IAcctUnitDetail } from "../../AccountService";
import { useDetailModel } from "../detailModel";
import { UserTypeEnum, AccountTypeEnum } from "@/types/FmsEnums";
import { OptionDsType } from "@/types/FmsTypes";
import { useGlobalModel } from "@/model/globalModel";
import { DictCodeEnmu } from "@/types/FmsDictEnums";
import { useLockFn } from "ahooks";

export const OpenAccountDrawer = () => {
    const {
        openDrawerVisible,
        setOpenDrawerVisible,
        onReset,
    } = useAccountModel(model => [model.openDrawerVisible]);

    const {
        orgDs,
        beDs,
        appDs,
        customer,
        accountTypeDs,
    } = useDetailModel(model => [
        model.customer,
        model.orgDs,
        model.beDs,
        model.appDs
    ]);
    const { user: { shopCode, shopName }, beShopDs, unit } = useGlobalModel();
    const [accountTypeData, setAccountTypeData] = useState<OptionDsType[]>([]);


    const formRef = useRef<IYhFormRef>();
    //账户更改
    const creditChange = (value: any) => {
        formRef.current?.setFieldsValue({ accountTypeCode: undefined })
    }
    const formConfig: IYhForm = {
        labelCol: { span: 6 },
        disabled: false,
        initialValues: {
            shopCode,
            unitCode: unit?.code,
            unitName: unit?.name,
            branch: 'fms',
            creditFlag: 1,
            accountTypeName: '门店核算账户',
            accountTypeCode: 'account-type.allot',
            // name: unit?.name + ""
        },
        items: [
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: "系统(分支)",
                fieldName: "branch",
                disable: false,
                span: 24,
                ds: appDs,
                rules: [{
                    required: true,
                    message: "系统(分支)不能为空"
                }],
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "核算单位",
                fieldName: "unitName",
                span: 24,
                disable: true,
                // rules: [{
                //     required: true,
                //     message: "核算单位不能为空"
                // }],
                // ds: unitDs,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "核算单位编码",
                fieldName: "unitCode",
                span: 24,
                disable: true,
                hidden: true,
                // rules: [{
                //     required: true,
                //     message: "核算单位不能为空"
                // }],
                // ds: unitDs,
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: "关联门店",
                fieldName: "shopCode",
                span: 24,
                disable: true,
                ds: [{ label: shopName, value: shopCode }],
                // rules: [{
                //     required: true,
                //     message: "关联门店不能为空"
                // }],
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: "关联实体",
                fieldName: "beCode",
                span: 24,
                ds: unit?.bentityList.map(item => ({ label: item.name as string, value: item.code as string })),
                rules: [{
                    required: true,
                    message: "关联机构不能为空"
                }],
                onSelectChange: () => {
                    let formVal = formRef.current?.getFieldsValue() ?? {};
                    const beName = unit?.bentityList.find(item => item.code === formVal.beCode)?.name
                    formRef.current?.setFieldsValue({ ...formVal, name: formVal.unitName + beName + formVal.accountTypeName })
                },
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: "授信类型",
                fieldName: "creditFlag",
                span: 24,
                rules: [{
                    required: true,
                    message: "授信类型不能为空"
                }],
                // onSelectChange: creditChange,
                ds: creditFlagDs(),
                disable: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "账户类型",
                fieldName: "accountTypeName",
                span: 24,
                disable: true,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "账户类型",
                fieldName: "accountTypeCode",
                span: 24,
                disable: true,
                hidden: true,
                // ds: accountTypeData,
                // onSelectFocus: () => {
                //     let formVal = formRef.current?.getFieldsValue() ?? {};
                //     if (formVal.creditFlag === undefined) return setAccountTypeData([]);
                //     let newVal = formVal.creditFlag;  //记账1   现金 0

                //     //在选择授信账户为记账时， 只展示 授信及月结，  否则返回其它
                //     setAccountTypeData(accountTypeDs.filter(item => newVal ? (item?.type === DictCodeEnmu.SETTLE_TYPE_CREDIT) : (item?.type === DictCodeEnmu.SETTLE_TYPE_CASH)));
                //     // setAccountTypeData(accountTypeDs.filter(item => newVal ?
                //     //     (item.value === AccountTypeEnum.CREDIT || item.value === AccountTypeEnum.CREDIT_MONTH || item.value === AccountTypeEnum.REBATE || item.value === AccountTypeEnum.REBATE_OIL) :
                //     //     (item.value !== AccountTypeEnum.CREDIT && item.value !== AccountTypeEnum.CREDIT_MONTH && item.value !== AccountTypeEnum.REBATE && item.value !== AccountTypeEnum.REBATE_OIL)))
                // },
                // rules: [{
                //     required: true,
                //     message: "账户类型不能为空"
                // }],
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "账户名称",
                fieldName: "name",
                span: 24,
                rules: [{
                    required: true,
                    message: "账户名称不能为空"
                }],
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "备注",
                fieldName: "note",
                span: 24,
            },
            // {
            //     type: FormItemTypeEnum.Input,
            //     fieldLabel: "开户客户",
            //     fieldName: "partnerName",
            //     disable: true,
            //     span: 24,
            //     rules: [{
            //         required: true,
            //         message: "系统(分支)不能为空"
            //     }],
            // },

            // {
            //     type: FormItemTypeEnum.TreeSelect,
            //     fieldLabel: "关联机构",
            //     fieldName: "orgCode",
            //     span: 24,
            //     treeData: orgDs,
            //     rules: [{
            //         required: true,
            //         message: "关联机构不能为空"
            //     }],
            // },
        ]
    };
    const onOk = useLockFn(async () => {
        try {
            let formData = await formRef.current?.validateFields();
            if (formData) {
                const reqData = {
                    ...formData,
                    shopName,
                    partnerTypeCode: UserTypeEnum.CUSTOMER,
                    partnerCode: customer.code,
                    // accountTypeName: formData?.accountTypeCode ? accountTypeDs.find(item => item.value === formData?.accountTypeCode)?.label : "",
                    beName: formData?.beCode ? beDs?.find(item => item.value === formData?.beCode)?.label : "",
                    orgName: formData?.orgCode ? orgDs?.find(item => item.key === formData?.orgCode)?.title ?? "" : "",
                    // unitName: formData?.unitCode ? unitDs?.find(item => item.value === formData?.unitCode)?.label ?? "" : "",
                };
                let insertRet = await accountService.allotOpen(reqData);
                if (insertRet.success) {
                    message.success("开户成功!");
                    onReset();
                    setOpenDrawerVisible(false);
                } else {
                    message.error("开户失败!" + insertRet.retMsg);
                }
            }
        } catch (e) {
            console.log("数据校验失败");
        }
    })
    const onCancel = () => {
        setOpenDrawerVisible(false);
    }

    return (
        <AppDrawer
            {...{
                title: "开户",
                visible: openDrawerVisible,
                closable: true,
                onOk,
                onCancel,
                showFooter: true
            }}
        >
            <YhForm formRef={formRef} {...formConfig} />
        </AppDrawer>
    )
}
